// Copyright (c) 2020 Deere & Company

import actionCreators from './action-creator/index';
import { connect } from 'react-redux';
import pinTransferSettings from './components/pin-search';
import { showLoadingIndicator } from '../../../sharedmodules/state/busy-counter';
import { withAuth } from '@okta/okta-react';

const mapStateToProps = (state) => ({
    userDealerMappedData: state.application.pinTransfersetting.pinSearch,
    busyCounter: showLoadingIndicator(state.application.busyCounter),
});

const mapActionsToProps = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps,
    },
});
export default connect(
    mapStateToProps, actionCreators, mapActionsToProps,
)(withAuth(pinTransferSettings));
